/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */
// This file was added to 'exclude' in tsconfig.app.json to prevent unused file warnings.

import {
	ICanvasDrawingModule,
	ICanvasDestroyable,
	ICanvasUpdateModule,
	AbstractApplication,
} from '@appCanvasCommon/core/AbstractApplication';
import { IDestroyOptions } from '@appCanvasCommon/core/DestroyOptions';

export abstract class AbstractDrawingModule
	implements ICanvasDestroyable, ICanvasDrawingModule, ICanvasUpdateModule
{
	protected destroyList: ICanvasDestroyable[] = [];
	protected parentApplication: AbstractApplication;
	constructor(parentApplication: AbstractApplication) {
		this.parentApplication = parentApplication;
	}
	public draw(...thing: any): void {}
	public update(...things: any): void {}
	public destroy(opts?: IDestroyOptions): void {
		this.destroyList.forEach((thing) => thing.destroy(opts));
	}
}
